import styled from 'styled-components';

export const PaymentDetailsBlockCard = styled.div`
  border: 1px solid #ccdde6;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(1, 83, 130, 0.1);

  display: flex;
  padding: 30px;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
`;
export const PaymentCard = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;
